import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { install } from '@material-ui/styles';
import { BrowserRouter } from 'react-router-dom';

import './Localization';

install();

ReactDOM.render(<BrowserRouter><App /></BrowserRouter>, document.getElementById("root"));
